import { toast } from "react-toastify";

export enum ErrorStatusTypes {
	OK = "ok",
	ERROR = "error",
	PENDING = "pending",
	SUCCESS = "success",
}
export interface ErrorsStack {
	status: ErrorStatusTypes;
	saving?: boolean;
	data?: [] | {};
	messages?: string[];
	errors?: [];
	fieldsErrors?: { [key: string]: string[] };
}

export function parseErrorMessage(error: any): ErrorsStack {
	try {
		// Tentativo di rimuovere il prefisso "Error: " se presente
		const message = error.message.replace(/^Error:\s*/, "");
		// Verifica se il messaggio sembra essere un JSON
		if (message.startsWith("{")) {
			const parsedMessage = JSON.parse(message);

			// 1. non_field_errors: errori generici di validazione form (DRF)
			if (parsedMessage.non_field_errors) {
				toast.error(parsedMessage.non_field_errors.join(", "), {
					autoClose: 7000,
				});
				return {
					status: ErrorStatusTypes.ERROR,
					messages: parsedMessage.non_field_errors,
				};
			}

			// 2. message: messaggio generico dal backend (es. errori di business logic)
			if (parsedMessage.message) {
				toast.error(parsedMessage.message, {
					autoClose: 7000,
				});
				return {
					status: ErrorStatusTypes.ERROR,
					messages: [parsedMessage.message],
				};
			}

			// 3. error: messaggio di errore generico
			if (parsedMessage.error) {
				toast.error(parsedMessage.error, {
					autoClose: 7000,
				});
				return {
					status: ErrorStatusTypes.ERROR,
					messages: [parsedMessage.error],
				};
			}

			// 4. detail: tipico di DRF per errori di autenticazione/permessi
			if (parsedMessage.detail) {
				toast.error(parsedMessage.detail, {
					autoClose: 7000,
				});
				return {
					status: ErrorStatusTypes.ERROR,
					messages: [parsedMessage.detail],
				};
			}

			// 5. Errori di campo (fieldsErrors): { campo: ["errore1", ...], ... }
			return {
				status: ErrorStatusTypes.ERROR,
				fieldsErrors: parsedMessage,
			};
		} else {
			// Il messaggio di errore è una stringa semplice, non JSON
			toast.error(message, {
				autoClose: 7000,
			});
			return {
				status: ErrorStatusTypes.ERROR,
				messages: [message],
			};
		}
	} catch (e) {
		const error = e as Error;
		toast.error(error.message, {
			autoClose: 7000,
		});
		return {
			status: ErrorStatusTypes.ERROR,
			messages: [`Errore di parsing: ${error.message}`],
		};
	}
}
